import {
    Modal,
    TextField,
    Button,
    makeStyles,
    Paper,
    IconButton,
    Typography,
    CardContent,
    Grid
} from "@material-ui/core";
import React, { useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import { Close } from "@material-ui/icons";
import * as Yup from "yup";
import { useFormik } from "formik";
import AppState from '../../context/AppContext'

const useStyles = makeStyles((theme) => ({
    input: {
        minWidth: '360px',
        backgroundColor: 'white',
        color: 'black',
        '& .MuiFormHelperText-root': {
            color: 'black',
        },
        '& .Mui-error': {
            color: 'black',
        },
    },
    errorText: {
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
    },
    card: {
        marginTop: '20px',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        margin: 'auto',
        maxWidth: '320px',
        padding: theme.spacing(2),
    },
    typography: {
        marginTop: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'center',
    },
    cardModal: {
        width: '100%',
    },
    closeButton: {
        float: 'right'
    },
}));

const AddChild = (props) => {
    const classes = useStyles();
    const auth = JSON.parse(sessionStorage.getItem("user"))
    const context = useContext(AppState)
    const validationSchema = Yup.object().shape( {
        name: Yup.string().required( 'Username is required' ),
        age: Yup.number().positive().integer().required("Required"),
    } );
    const handleClose = () => {
        props.handleClose();
        resetForm()
    };
    const onSubmit = (values) => {
        const childUid = uuidv4();
        let child = {
            name: values.name,
            age: values.age,
            uid: childUid,
            list: [],
        };
        context.store.children.push( child );
        const data = {
            name: values.name,
            age: values.age,
            childUid: childUid,
        };
        context.addChildDB(auth.user._id, data).then((data) => {
            context.setStore({
                ...context.store,
                addForm: false,
            });
        });
        handleClose();
    };
    const {
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        resetForm
    } = useFormik( {
        initialValues: {
            name: '',
            age:''
        },
        validationSchema: validationSchema,
        onSubmit,
    } );
    return (
        <Modal open={props.open} className={classes.modal}>
            <Paper className={classes.paper}>
                <IconButton className={classes.closeButton} onClick={handleClose}>
                    <Close />
                </IconButton>
                <Paper className={classes.card}>
                    <Typography variant="h5">Add Child</Typography>
                    <CardContent>
                        <form onSubmit={handleSubmit} autoComplete="off" className={classes.form}>
                            <TextField
                                name="name"
                                value={values.name}
                                onChange={handleChange}
                                id="name"
                                label="User Name"
                                type="text"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                placeholder="Enter name for your child"
                                onBlur={handleBlur}
                                error={Boolean( errors.name && touched.name )}
                                helperText={touched.name ? errors.name : ""}
                            />
                            <TextField
                                name="age"
                                value={values.age}
                                onChange={handleChange}
                                id="age"
                                label="Child Age"
                                type="number"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                placeholder="Enter age for your child"
                                onBlur={handleBlur}
                                error={Boolean( errors.age && touched.age )}
                                helperText={touched.age ? errors.age : ""}
                            />
                            <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                                <Grid item>
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" onClick={handleClose}>
                                        Cancel
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </CardContent>
                </Paper>
            </Paper>
        </Modal>
    );
};

export default AddChild;
